<template>
  <multiselect
    v-model="dataValue"
    :options="availableOptions"
    :multiple="multiple"
    :close-on-select="true"
    :clear-on-select="false"
    :preserve-search="true"
    :placeholder="placeholder"
    deselectLabel="X"
    selectedLabel="✓"
    selectLabel="✓"
    :searchable="searchable"
    :track-by="trackBy"
    :openDirection="openDirection"
    :label="labelBy"
    @select="(option, id) => $emit('select', option, id)"
    @remove="(option, id) => $emit('remove', option, id)"
  >
    <template v-slot:noOptions>
      <span style="font-family: 'Open Sans', sans-serif;font-size: 14px; "
        >Leer</span
      >
    </template>
    <template v-slot:noResult>
      <span style="font-family: 'Open Sans', sans-serif;font-size: 14px; "
        >Kein Ergebnis</span
      >
    </template>
    <template slot="option" slot-scope="props">
      <div class="option__desc" :title="props.option.name || props.option">
        <span class="option__title">{{
          props.option.name || props.option
        }}</span>
      </div>
    </template>
  </multiselect>
</template>
<script>
import Multiselect from "vue-multiselect";
import _ from "lodash";
export default {
  components: {
    Multiselect
  },
  props: {
    openDirection: {
      type: String,
      default() {
        return "";
      }
    },
    multiple: {
      type: Boolean,
      default() {
        return true;
      }
    },
    placeholder: {
      type: String,
      default() {
        return "Auswählen";
      }
    },
    searchable: {
      type: Boolean,
      default() {
        return true;
      }
    },
    value: {
      type: Array | Object
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      dataOptions: [],
      dataValue: []
    };
  },
  computed: {
    availableOptions() {
      return _.difference(this.dataOptions, this.dataValue);
    },
    labelBy() {
      if (!this.useLabel) {
        return "";
      }
      return "name";
    },
    trackBy() {
      if (!this.useTrackById) {
        return "";
      }
      return "id";
    },
    useTrackById() {
      return this.options && this.options.length && this.options[0].id;
    },
    useLabel() {
      return this.options && this.options.length && this.options[0].name;
    }
  },
  methods: {
    setDataValue(value) {
      console.log("setDataValue", value);
      if (!_.isNil(value) && !Object.keys(value).length && !_.isArray(value)) {
        value = null;
      }
      this.dataValue = value;
    },
    truncateString(str) {
      return _.truncate(str);
    }
  },
  watch: {
    dataValue(newVal) {
      if (!newVal && !_.isArray(newVal)) {
        newVal = {};
      }
      this.$emit("input", newVal);
    },
    options(newVal) {
      this.dataOptions = newVal;
    },
    value(newVal) {
      this.setDataValue(newVal);
    }
  },
  mounted() {
    this.setDataValue(this.value);
    this.dataOptions = this.options;
  }
};
</script>
<style>
.multiselect {
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  min-height: 32px;
}
.multiselect__tags {
  min-height: 32px;
  padding: 4px 40px 0 8px;
  border: 1px solid #ccd0d4;
  border-radius: 4px;
  background: #fff;
  font-size: 13px;
  transition: border-color 0.15s ease;
}
.multiselect--active .multiselect__tags {
  border-color: #439dc8;
  box-shadow: 0 0 0 2px rgba(67, 157, 200, 0.15);
}
.multiselect__tag {
  font-family: "Open Sans", sans-serif;
  background: #439dc8;
  color: #fff;
  font-size: 13px;
  border-radius: 3px;
  padding: 3px 22px 3px 8px;
  margin-bottom: 2px;
}
.multiselect__tag-icon {
  border-radius: 3px;
}
.multiselect__tag-icon:hover {
  background: #357ea0;
}
.multiselect__tag-icon::after {
  color: #fff;
}
.multiselect__option {
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  padding: 8px 12px;
  min-height: 32px;
  white-space: normal;
  word-break: break-word;
}
.multiselect__option--highlight {
  background: #439dc8;
  color: #fff;
}
.multiselect__option--highlight::after {
  background: #439dc8;
  color: #fff;
}
.multiselect__option--selected {
  background: #e8f4f9;
  color: #333;
  font-weight: 600;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #357ea0;
  color: #fff;
}
.multiselect__option--selected.multiselect__option--highlight::after {
  background: #357ea0;
  color: #fff;
}
.multiselect__select {
  height: 30px;
  padding: 2px 8px;
}
.multiselect__select::before {
  border-color: #999 transparent transparent;
}
.multiselect__placeholder {
  font-size: 13px;
  color: #999;
  padding-top: 0;
  margin-bottom: 4px;
}
.multiselect__input,
.multiselect__single {
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  margin-bottom: 4px;
  padding-top: 0;
}
.multiselect__content-wrapper {
  max-height: 240px !important;
  border: 1px solid #ccd0d4;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.option__title {
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
}
</style>
